import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {ImageViewerItem} from "@numizmat/services-models/common";

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {
  private images$: BehaviorSubject<ImageViewerItem[]> = new BehaviorSubject<ImageViewerItem[]>([]);

  public getImages(): Observable<ImageViewerItem[]> {
    return this.images$.asObservable();
  }

  public setImages(images: string[], index?: number): void {
    let currentImages: string[] = [];
    if (index !== undefined && index >= 0 && index < images.length) {
      currentImages.push(...images.slice(index));
      currentImages.push(...images.slice(0, index));
    } else {
      currentImages = images;
    }
    const promises = currentImages.map((url) => this.fetchImageSize(url));
    Promise.all(promises).then((imageDetails) => {
      this.images$.next(imageDetails);
    });
  }

  private fetchImageSize(url: string): Promise<ImageViewerItem> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        resolve({url, width: image.naturalWidth, height: image.naturalHeight});
      };
      image.onerror = reject;
    });
  }
}
